export default "dashboard:\n  title: 의료 대시보드\npatients:\n  title: 환자 관리\n  detail: 환자 상세\ninquiries:\n  title: 의료 문의\n"